import { Option } from '@/models/interfaces';
import toKey from '@/utils/toKey';

const ESP_ZIP_TABLE: {
  [code: string]: { aL6: string; aL4: string };
} = {
  '01': { aL6: 'Alava', aL4: 'Pays basque' },
  '02': { aL6: 'Albacete', aL4: 'Castille-La Manche' },
  '03': { aL6: 'Alicante', aL4: 'Communauté valencienne' },
  '04': { aL6: 'Almería', aL4: 'Andalousie' },
  '05': { aL6: 'Ávila', aL4: 'Castille-et-León' },
  '06': { aL6: 'Badajoz', aL4: 'Estrémadure' },
  '07': { aL6: 'Îles Baléares', aL4: 'Îles Baléares' },
  '08': { aL6: 'Barcelone', aL4: 'Catalogne' },
  '09': { aL6: 'Burgos', aL4: 'Castille-et-León' },
  '10': { aL6: 'Cáceres', aL4: 'Estrémadure' },
  '11': { aL6: 'Cadix', aL4: 'Andalousie' },
  '12': { aL6: 'Castellón', aL4: 'Communauté valencienne' },
  '13': { aL6: 'Ciudad Real', aL4: 'Castille-La Manche' },
  '14': { aL6: 'Cordoue', aL4: 'Andalousie' },
  '15': { aL6: 'La Corogne', aL4: 'Galice' },
  '16': { aL6: 'Cuenca', aL4: 'Castille-La Manche' },
  '17': { aL6: 'Gérone', aL4: 'Catalogne' },
  '18': { aL6: 'Grenade', aL4: 'Andalousie' },
  '19': { aL6: 'Guadalajara', aL4: 'Castille-La Manche' },
  '20': { aL6: 'Guipuscoa', aL4: 'Pays basque' },
  '21': { aL6: 'Huelva', aL4: 'Andalousie' },
  '22': { aL6: 'Huesca', aL4: 'Aragon' },
  '23': { aL6: 'Jaén', aL4: 'Andalousie' },
  '24': { aL6: 'León', aL4: 'Castille-et-León' },
  '25': { aL6: 'Lleida', aL4: 'Catalogne' },
  '26': { aL6: 'La Rioja', aL4: 'La Rioja' },
  '27': { aL6: 'Lugo', aL4: 'Galice' },
  '28': { aL6: 'Madrid', aL4: 'Communauté de Madrid' },
  '29': { aL6: 'Malaga', aL4: 'Andalousie' },
  '30': { aL6: 'Murcie', aL4: 'Région de Murcie' },
  '31': { aL6: 'Navarre', aL4: 'Navarre' },
  '32': { aL6: 'Orense', aL4: 'Galice' },
  '33': { aL6: 'Asturies', aL4: 'Asturies' },
  '34': { aL6: 'Palencia', aL4: 'Castille-et-León' },
  '35': { aL6: 'Las Palmas', aL4: 'Îles Canaries' },
  '36': { aL6: 'Pontevedra', aL4: 'Galice' },
  '37': { aL6: 'Salamanque', aL4: 'Castille-et-León' },
  '38': { aL6: 'Santa Cruz de Tenerife', aL4: 'Îles Canaries' },
  '39': { aL6: 'Cantabrie', aL4: 'Cantabrie' },
  '40': { aL6: 'Ségovie', aL4: 'Castille-et-León' },
  '41': { aL6: 'Séville', aL4: 'Andalousie' },
  '42': { aL6: 'Soria', aL4: 'Castille-et-León' },
  '43': { aL6: 'Tarragone', aL4: 'Catalogne' },
  '44': { aL6: 'Teruel', aL4: 'Aragon' },
  '45': { aL6: 'Tolède', aL4: 'Castille-La Manche' },
  '46': { aL6: 'Valence', aL4: 'Communauté valencienne' },
  '47': { aL6: 'Valladolid', aL4: 'Castille-et-León' },
  '48': { aL6: 'Biscaye', aL4: 'Pays basque' },
  '49': { aL6: 'Zamora', aL4: 'Castille-et-León' },
  '50': { aL6: 'Saragosse', aL4: 'Aragon' },
  '51': { aL6: 'Ceuta', aL4: 'Ceuta' },
  '52': { aL6: 'Melilla', aL4: 'Melilla' },
};

const ESP_OPTIONS: Array<Option> = [
  { value: 'andalousie', label: 'Andalousie' },
  { value: '04', label: '↳ Almería' },
  { value: '11', label: '↳ Cadix' },
  { value: '14', label: '↳ Cordoue' },
  { value: '18', label: '↳ Grenade' },
  { value: '21', label: '↳ Huelva' },
  { value: '23', label: '↳ Jaén' },
  { value: '29', label: '↳ Malaga' },
  { value: '41', label: '↳ Séville' },
  { value: 'aragon', label: 'Aragon' },
  { value: '22', label: '↳ Huesca' },
  { value: '50', label: '↳ Saragosse' },
  { value: '44', label: '↳ Teruel' },
  { value: 'asturies', label: 'Asturies' },
  { value: '33', label: '↳ Asturies' },
  { value: 'cantabrie', label: 'Cantabrie' },
  { value: '39', label: '↳ Cantabrie' },
  { value: 'castille-la_manche', label: 'Castille-La Manche' },
  { value: '02', label: '↳ Albacete' },
  { value: '13', label: '↳ Ciudad Real' },
  { value: '16', label: '↳ Cuenca' },
  { value: '19', label: '↳ Guadalajara' },
  { value: '45', label: '↳ Tolède' },
  { value: 'castille-et-leon', label: 'Castille-et-León' },
  { value: '05', label: '↳ Ávila' },
  { value: '09', label: '↳ Burgos' },
  { value: '24', label: '↳ León' },
  { value: '34', label: '↳ Palencia' },
  { value: '37', label: '↳ Salamanque' },
  { value: '40', label: '↳ Ségovie' },
  { value: '42', label: '↳ Soria' },
  { value: '47', label: '↳ Valladolid' },
  { value: '49', label: '↳ Zamora' },
  { value: 'catalogne', label: 'Catalogne' },
  { value: '08', label: '↳ Barcelone' },
  { value: '17', label: '↳ Gérone' },
  { value: '25', label: '↳ Lleida' },
  { value: '43', label: '↳ Tarragone' },
  { value: 'ceuta', label: 'Ceuta' },
  { value: '51', label: '↳ Ceuta' },
  { value: 'communaute_de_madrid', label: 'Communauté de Madrid' },
  { value: '28', label: '↳ Madrid' },
  { value: 'communaute_valencienne', label: 'Communauté valencienne' },
  { value: '03', label: '↳ Alicante' },
  { value: '12', label: '↳ Castellón' },
  { value: '46', label: '↳ Valence' },
  { value: 'estremadure', label: 'Estrémadure' },
  { value: '06', label: '↳ Badajoz' },
  { value: '10', label: '↳ Cáceres' },
  { value: 'galice', label: 'Galice' },
  { value: '15', label: '↳ La Corogne' },
  { value: '27', label: '↳ Lugo' },
  { value: '32', label: '↳ Orense' },
  { value: '36', label: '↳ Pontevedra' },
  { value: 'iles_baleares', label: 'Îles Baléares' },
  { value: '07', label: '↳ Îles Baléares' },
  { value: 'iles_canaries', label: 'Îles Canaries' },
  { value: '35', label: '↳ Las Palmas' },
  { value: '38', label: '↳ Santa Cruz de Tenerife' },
  { value: 'la_rioja', label: 'La Rioja' },
  { value: '26', label: '↳ La Rioja' },
  { value: 'melilla', label: 'Melilla' },
  { value: '52', label: '↳ Melilla' },
  { value: 'navarre', label: 'Navarre' },
  { value: '31', label: '↳ Navarre' },
  { value: 'pays_basque', label: 'Pays basque' },
  { value: '01', label: '↳ Alava' },
  { value: '48', label: '↳ Biscaye' },
  { value: '20', label: '↳ Guipuscoa' },
  { value: 'region_de_murcie', label: 'Région de Murcie' },
  { value: '30', label: '↳ Murcie' },
];

function getSpannishOSM(input: string): { aL6: string; aL4: string } | null {
  let found: { aL6: string; aL4: string } | undefined = undefined;
  if (parseInt(input)) {
    if (input.length > 2) input = input.slice(0, 2);
    if (input.length === 1) input = '0' + input;
    found = ESP_ZIP_TABLE[input];
    if (found) found = JSON.parse(JSON.stringify(found));
  }
  if (!found) {
    found = Object.values(ESP_ZIP_TABLE).find((it) => input == toKey(it.aL6));
    if (found) found = JSON.parse(JSON.stringify(found));
  }
  if (!found) {
    found = Object.values(ESP_ZIP_TABLE).find((it) => input == toKey(it.aL4));
    if (found) found = JSON.parse(JSON.stringify(found));
    if (found) found.aL6 = '';
  }
  return found ?? null;
}

export { ESP_OPTIONS, getSpannishOSM };
